export interface NotificationObject {
  imageUrl?: string;
  href?: string;
  heading: string;
  body: string;
  buttonText?: string;
  secondButtonText?: string;
  secondHref?: string;
  eventInfo?: React.SyntheticEvent;
}

export const errorTemplate = (data: NotificationObject) => /* html */ `
<button type="button" class="close p-2 mr-2 top-1" aria-label="close">
<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M7.00023 5.58599L11.9502 0.635986L13.3642 2.04999L8.41423 6.99999L13.3642 11.95L11.9502 13.364L7.00023 8.41399L2.05023 13.364L0.63623 11.95L5.58623 6.99999L0.63623 2.04999L2.05023 0.635986L7.00023 5.58599Z" fill="black"/>
</svg>
</button>
<span class="notification__content flex items-center gap-3 mr-6 mb-3 ml-2 relative">
  <div class="bg-red-500 absolute w-2 h-36 -left-5"></div>
  <svg class="flex-shrink-0" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.1546 3.99998L29.856 26C29.973 26.2027 30.0346 26.4326 30.0346 26.6666C30.0346 26.9007 29.973 27.1306 29.856 27.3333C29.739 27.536 29.5706 27.7043 29.368 27.8213C29.1653 27.9384 28.9353 28 28.7013 28H3.29863C3.06459 28 2.83466 27.9384 2.63198 27.8213C2.42929 27.7043 2.26098 27.536 2.14396 27.3333C2.02694 27.1306 1.96533 26.9007 1.96533 26.6666C1.96533 26.4326 2.02694 26.2027 2.14396 26L14.8453 3.99998C14.9623 3.79731 15.1306 3.629 15.3333 3.51199C15.536 3.39498 15.7659 3.33337 16 3.33337C16.234 3.33337 16.4639 3.39498 16.6666 3.51199C16.8693 3.629 17.0376 3.79731 17.1546 3.99998ZM5.60796 25.3333H26.392L16 7.33332L5.60796 25.3333ZM14.6666 21.3333H17.3333V24H14.6666V21.3333ZM14.6666 12H17.3333V18.6666H14.6666V12Z" fill="#BC3200"/>
  </svg>
  <div class="flex flex-col">
    <p class="font-bold text-base leading-5 m-0">${data.heading}</p>
    <p class="text-base leading-5 m-0">${data.body}</p>
  </div>
</span>`;

export default (data: NotificationObject) => /* html */ `
<button type="button" class="close p-2 mr-2 top-1" aria-label="close">
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7.00023 5.58599L11.9502 0.635986L13.3642 2.04999L8.41423 6.99999L13.3642 11.95L11.9502 13.364L7.00023 8.41399L2.05023 13.364L0.63623 11.95L5.58623 6.99999L0.63623 2.04999L2.05023 0.635986L7.00023 5.58599Z" fill="black"/>
  </svg>
</button>
${
  data.imageUrl
    ? /* html */ `
  <div class="notification__img">
      <img src="${data.imageUrl}" alt="">
  </div>`
    : ""
}
<div class="notification__content">
    <div id="${data.body?.replace(/\s+/g, "")}">
      <h2 class="notification__heading">${data.heading}</h2>
      <div class="notification__description">${data.body ? data.body : ""}</div>
    </div>
    <div class="notification__action">
      ${
        data.buttonText
          ? /* html */ `
        <a href="${data.href}" class="btn btn-small btn-primary">${data.buttonText}</a>
      `
          : ""
      }
      ${
        data.secondButtonText
          ? /* html */ `
        <a href="${data.secondHref}" class="btn btn-small btn-orange">${data.secondButtonText}</a>
      `
          : ""
      }
    </div>
</div>`;
